import HappyFace from './assets/happy.js'
import ConfusedFace from './assets/confused.js'
import WearyFace from './assets/weary.js'

const TopicHelpfulness = (props) => {
  return (
    <div
      className={`topic-helpfulness_container
          ${props.isVoted ? 'topic-helpfulness__voted' : ''}
          ${props.animationClass ? props.animationClass : ''}
          ${props.isSticky ? 'topic-helpfulness_float-bar' : 'topic-helpfulness_widget'}`
      }
    >
      {
        !props.isVoted ? (
          <div className={'topic-helpfulness'}>
            <div className={'topic-helpfulness_header'}>
              <div className={'topic-helpfulness-text'}>
                <span> {props.phrases['topic.helpfulness.text']} </span>
              </div>
              {
                props.showIndicator ? (
                  <span className='text--meta qa-topic-helpful-impact'>
                    <span className='qa-topic-helpful-percentage' data-score={props.indicatorPercentage}>
                      {props.indicatorPercentage}% </span>
                    <span> {props.phrases['topic.helpfulness.indicator']} </span>
                  </span>
                ) : null
              }
            </div>
            <span className='topic-helpfulness_reactions'>
              <span onClick={() => props.setData('topichelpful')} className='topic-helpfulness_reaction qa-topic-helpful-icon'>
                <HappyFace />
              </span>
              <span onClick={() => props.setData('topicneutral')} className='topic-helpfulness_reaction qa-topic-neutral-icon'>
                <ConfusedFace />
              </span>
              <span onClick={() => props.setData('topicnothelpful')} className='topic-helpfulness_reaction qa-topic-nothelpful-icon'>
                <WearyFace />
              </span>
            </span>
            {
              props.isSticky ? <span onClick={() => props.hideWidget()} className='topic-helpfulness_dismiss' /> : null
            }
          </div>
        ) : <span> {props.phrases['topic.helpfulness.thanks']} </span>
      }
    </div>
  )
}

export default TopicHelpfulness
